const router = (state = {isAdmin: false}, action) => {
    switch (action.type) {
        case 'SET_ADMIN':
            return {...state, isAdmin: action.isAdmin};
        default:
            return state;
    }
};

export default router;